import React from 'react';
import { Box, Divider } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { DetailRow } from 'common/components/DetailRow';
import { IUserType } from 'graphql/types';
import { ButtonLink } from 'common/components/buttons/ButtonLink';
import { CrownIcon } from 'common/components/icons';

interface IProps {
    basic?: boolean;
    className?: string;
    user: Pick<
        IUserType,
        | 'id'
        | 'firstName'
        | 'lastNamePrefix'
        | 'lastName'
        | 'email'
        | 'jobTitle'
        | 'phone'
        | 'isMainUser'
    >;
    onEditClick(): void;
    onPasswordResetClick(): void;
}

export const BaseDetailView = ({
    basic,
    className,
    user,
    onEditClick,
    onPasswordResetClick,
}: IProps) => {
    const { t } = useTranslation();

    return (
        <Box className={className}>
            <Box mt={!basic ? 0 : 6}>
                <Box display="flex">
                    <DetailRow
                        bold
                        description={!basic ? t('user.name') : undefined}
                    >
                        {`${user.firstName} ${user.lastNamePrefix}  ${user.lastName}`}
                    </DetailRow>

                    {user.isMainUser && (
                        <Box ml="auto" position="relative" top="-8px">
                            <CrownIcon />
                        </Box>
                    )}
                </Box>
                <DetailRow
                    description={!basic ? t('formfields.jobTitle') : undefined}
                >
                    {user.jobTitle}
                </DetailRow>
                <Box mt={8}>
                    <DetailRow
                        description={!basic ? t('formfields.email') : undefined}
                    >
                        {user.email}
                    </DetailRow>
                    <DetailRow
                        description={!basic ? t('formfields.phone') : undefined}
                    >
                        {user.phone}
                    </DetailRow>
                </Box>
            </Box>

            {!basic && (
                <>
                    <Box mb={8} mt={8}>
                        <Divider />
                    </Box>
                    <Box display="flex" flexDirection="column">
                        <Box mb={3}>
                            <ButtonLink
                                icon={<ArrowForwardIcon />}
                                onClick={onEditClick}
                            >
                                {t('user.editData')}
                            </ButtonLink>
                        </Box>
                        <ButtonLink
                            className="link"
                            icon={<ArrowForwardIcon />}
                            onClick={onPasswordResetClick}
                        >
                            {t('user.resetPassword')}
                        </ButtonLink>
                    </Box>
                </>
            )}
        </Box>
    );
};

export const DetailView = styled(BaseDetailView)``;
